import Vue from 'vue';
import Vuex from 'vuex';
import race from './modules/race';
import user from './modules/user';
import {instance, instanceJSON} from '@/api';
import {translationApi, generalApi, guideApi, contentPageApi} from '@/api';
import {localSt} from "@/store/localStorage.js";
import {snakeCase} from "@/mixins/static-helpers";

import Cookie from 'js-cookie';
import _ from 'lodash';

Vue.use(Vuex);

const defaultLang = 'fr';

function getLanguage(){
	let lang =  Cookie.get('lnl-lang');

	if(typeof lang !== 'undefined' && lang !== null){
		return lang;
	}else{
		return defaultLang;
	}
}

var ln = getLanguage();





export default new Vuex.Store({
	state: {
		version: (window.VUE_APP_VERSION || process.env.VUE_APP_VERSION),
		cookiebar: null,
		cookiebarId: 'lnl-cookie',

		langPromise: null,
		lang: ln,
		langList: [
			'en',
			'fr'
		],
		translations: localSt.fetch('translations'),


		loaderList: [],

		refreshList: [
			'getRacesData',
			'userRefreshAction',
			'updateSessionTime'
		],

		maintenance: {
			mntOK: null,
			dbOK: null
		},
		envPromise: null,
		env: {
			navigation: {
				header: [
					{
						"id": 1,
						"path": "/timeline",
						"label": "Navigation field name",
						"requireLogin": false,
						"blank": false
					},
				],
				footer: []
			},
			lang_bar: false,
			reCaptchaSiteKey: '6LdAmGQUAAAAAFm4rIsGLsqrS7N_IluPkWuNmwFo',
			gMapToken: 'AIzaSyCG02x_5JinP5f8dEAI2EbUBTFMx6C5oY8',
		},
		sport:{
			enable: window.APP_SPORT_ENABLE,
			domain: window.APP_SPORT_URL
		},
		token: localSt.fetch('CSRFtoken'),
		loginModal: false,

		//Home page slider
		slides: {
			timing: 3000,
			slider: []
		},

		once: {
			betGuide: [],
			banners: null
		},

		breakpoint: {
			size: null,
			width: 0,
			abs: 0  // Absolute value by steps:
			// 0 - mobile,
			// 1 - medium,
			// 2 - large,
			// 3 - huge.
			// For cases when several steps, should be affected.
		},

		modals: []
	},
	modules: {

		race,
		user
	},
	mutations: {

		showLoginModal(state){
			state.loginModal = true;
		},
		hideLoginModal(state){
			state.loginModal = false;
		},

		addLoad(state, loadName) {

			if (state.loaderList.indexOf(loadName) === -1) {
				state.loaderList.push(loadName);
			}
		},
		endLoad(state, loadName) {

			let indx = state.loaderList.indexOf(loadName);
			if (indx > -1) {
				state.loaderList.splice(indx, 1);
			}
		},

		addModal(state, modalName){

			if (state.modals.indexOf(modalName) === -1) {
				state.modals.push(modalName);
			}
		},
		removeModal(state, modalName) {

			let indx = state.modals.indexOf(modalName);
			if (indx > -1) {
				state.modals.splice(indx, 1);
			}
		},


		changeLang(state, lang) {
			state.lang = lang;
			Cookie.set('lnl-lang', lang, { expires: 7 });
			this.dispatch('getTranslations', lang);
		},
		addRefresh(state, action) {
			//Add vuex Action to refresh list
			if (state.refreshList.indexOf(action) === -1) {
				state.refreshList.push(action);
			}
		},
		removeRefresh(state, action) {
			state.refreshList = _.pull(state.refreshList, action);

		},
		setTranslations(state, translations) {
			state.translations = translations;
		},
		setEnv(state, data) {

			//Set env data
			state.env = data;

			//Check if default lang are not same, then change it, BUT please hardcode default lang
			if (state.lang !== data.lang && !Cookie.get('lnl-lang')) {
				this.commit('changeLang', data.lang);
			}
		},
		gotSlides(state, data){
			state.slides = data;
		},
		gotBetGuides(state, data){
			if(data){

				state.once.betGuide = data.sort( (a, b)=> a.id-b.id );
			}
		},
		gotBanners(state, data){
			state.once.banners = data;
		},

		setDbStatus(state, status){
			state.maintenance.dbOK = status;
		},
		setMntStatus(state, status){
			state.maintenance.mntOK = status;
		},
		setCSRFtoken(state, token){
			state.token = token;
			localSt.save('CSRFtoken', token)
		},
		setCookieBar(state){
			Cookie.set(state.cookiebarId, true, { expires: 7 });

			state.cookiebar = false;
		},

		setViewport(state, vp){

			state.breakpoint.width = vp;

			/*
			*
				$screen-xs: 480px; // @respond-to ('small') and overwrite bootstrap grid. Overwrite grid
				$screen-sm: 768px; // @respond-to ('medium') and overwrite bootstrap grid. Overwrite grid
				$screen-md: 1024px; // @respond-to ('large') and overwrite bootstrap grid. Overwrite grid
				$screen-lg: 1200px;
			*
			* */


			if(vp <= 480){

				state.breakpoint.size = 'small';
				state.breakpoint.abs = 0;

			}else if(vp > 480 && vp < 768){

				state.breakpoint.size = 'medium';
				state.breakpoint.abs = 1;

			}else if(vp >= 768 && vp <= 1024){

				state.breakpoint.size = 'large';
				state.breakpoint.abs = 2;
			}else{

				state.breakpoint.size = 'huge';
				state.breakpoint.abs = 3;

			}

		}
	},
	getters: {
		getSitekey(state) {
			return state.env.reCaptchaSiteKey;
		},
		getMapToken(state) {
			return state.env.gMapToken;
		},
		getHeaderNav(state) {
			return state.env.navigation.header;
		},
		getFooterNav(state) {
			return state.env.navigation.footer;
		},
		maintenanceStatus(state){
			return (state.maintenance.dbOK !== null && state.maintenance.dbOK === false) || (state.maintenance.mntOK !== null && state.maintenance.mntOK === false)

		},
		csrf_token(){
			return localSt.fetch('CSRFtoken');
		},
		cookieBar(state){

			let cb = Cookie.get(state.cookiebarId);

			if(typeof cb !== 'undefined'){

				//Renew cookie bar
				Cookie.set(state.cookiebarId, true, { expires: 7 });

				state.cookiebar = false;

			}else{
				state.cookiebar = true;
			}

			return state.cookiebar;
		},
		breakpoint(state){

			return state.breakpoint;
		},
		getTypeByName: state => name =>{

			const nm = snakeCase(name);

			let result = state.once.betGuide.find((el)=> snakeCase(el.name) === nm);

			if(result){
				return result;
			}

			return {title: name};

		}
	},
	actions: {


		getTranslations({state, commit}, lang) {
			//Set temporary translations
			commit('setTranslations', localSt.fetch('translations'));

			state.langPromise = instance.get(translationApi.all + lang)
				.then((responce) => {
					if (responce.data && responce.data.content) {
						let tmp = {};
						tmp[lang] = {};

						for (let pair of responce.data.content.translations) {
							tmp[lang][pair.keyword] = pair.translation;
						}

						commit('setTranslations', Object.assign({}, state.translations, tmp));
						localSt.save('translations', state.translations);
					} else {
						console.warn('Translation request error');
					}

				});
		},
		getEnv({state, commit}) {
			state.envPromise = instance.get(generalApi.env)
				.then((responce) => {

					if (responce.data && responce.data.content && responce.data.status && responce.data.status === 'SUCCESS') {
						commit('setEnv', responce.data.content);
					} else {
						console.warn('Env request error');
					}


				});
		},
		async getHomePageSlider({commit}){
			const {data} = await instance.get(generalApi.slider);

			if(typeof data.error === 'undefined'){
				commit ('gotSlides', data.content);
			}
		},
		getBetGuides({state, commit}){

			if(state.once.betGuide.length === 0){
				return instance.get(guideApi.all).then((response)=>{
					if(typeof response.data.error === 'undefined'){
						commit ('gotBetGuides', response.data.content);
					}
				});
			}else{
				return new Promise((resolve)=>{
					setTimeout(()=>{
						resolve();
					},10);
				})
			}

		},
		getBanners({state, commit}){

			if(state.once.banners === null){
				state.once.banners = [];
				return instance.get(contentPageApi.banners).then((response)=>{
					if(typeof response.data.error === 'undefined'){
						commit ('gotBanners', response.data.content);
					}
				});
			}

		},

		getMaintenanceStatus({commit}){

			instanceJSON.get(generalApi.maintenance).then(({data})=>{

				if(data.status === 'SUCCESS'){
					//All ok keep working
					commit('setMntStatus', true);
					commit('setDbStatus', true);
				}else{
					//Check maintenance planned
					if(data.content.maintenance['conf_value'] && data.content.maintenance['conf_value'] === '0' ){
						commit('setMntStatus', true);
					}else{
						commit('setMntStatus', false);
					}

					//Check db status
					if(data.content.db.status === 'SUCCESS' && data.content.db.message === 'connected_to_db' ){
						commit('setDbStatus', true);
					}else{
						commit('setDbStatus', false);
					}


				}

			}).catch(()=>{
				commit('setMntStatus', false);
				commit('setDbStatus', false);
			});
		}
	}
});
